<div class="bu-details-line" [innerHTML]="buDetailsLineSafe">
</div>

